import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Button, FormControl, Table, Spinner } from "react-bootstrap";
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useDispatch } from "react-redux";
import { Fn_FillListData, Fn_GetReport } from "../../store/Functions";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const PageList_AdminCartApprove = () => {
  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      fileUpload: null,
      IsActive: false,
      F_ItemTypeMaster: -1, // Initialize with default value
    },
    FillArray: [],
    productData: [],
    isProgress: true,
  });
  const [gridData, setGridData] = useState([]);
  const [newData, setNewData] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const breadCrumbTitle = "Sale Master";
  const breadcrumbItem = "Sale Master";
  const rtPage_Add = "/AddSales";
  const rtPage_Edit = "/EditSales";
  const API_URL = API_WEB_URLS.MASTER + "/0/token/CartApproveList";
  const API_URL1 = API_WEB_URLS.MASTER + "/0/token/ApproveStockByAdmin";
  const API_URL2 = "GetRemainingStocks/0/token";

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Fn_FillListData(dispatch, setGridData, "gridData", API_URL + "/Id/0");

      // Process gridData to set flags for duplicate Ids
      setGridData((prevData) => {
        const processedData = prevData.map((row, index, arr) => ({
          ...row,
          showCustomerDetails:
            index === 0 || row.Id !== arr[index - 1].Id, // Show for the first occurrence of an Id
          showEditButton:
            index === 0 || row.Id !== arr[index - 1].Id, // Show Edit button for the first occurrence of an Id
        }));
        return processedData;
      });

      setLoading(false);
    };

    fetchData();
  }, []);

  const btnAddOnClick = () => {
    navigate(rtPage_Add, { state: { Id: 0 } });
  };

  const btnEditOnClick = (Id) => {
    navigate(rtPage_Edit, { state: { Id } });
  };



  const handleApprove = async (row) => {
    await Fn_FillListData(dispatch, setGridData, "gridData", API_URL1 + "/"+1+"/"+row.Id);
    window.location.reload();
    // try {
    //   // Fetch stock data for the salesperson
    //   let vformData = new FormData();
    //   vformData.append("F_SalesMaster", row.SalePersonId);
  
    //   const response = await Fn_GetReport(
    //     dispatch,
    //     setState,
    //     "productData",
    //     API_URL2,
    //     { arguList: { id: 0, formData: vformData } },
    //     true
    //   );
    //  let cartData =   await Fn_FillListData(dispatch, setNewData, "newData", API_URL + "/Id/0");
    //   cartData = Array.isArray(cartData) && cartData.filter((item)=>item.Id == row.Id)
    //   console.log(cartData)
    //   if (response && Array.isArray(response) && cartData.length>0) {
    //     const stockData = response;
    //     const issues = [];
  
    //     // Create a copy of gridData for processing
   
  
    //     // Compare stock with cart
    //     for (let cartItem of cartData) {
    //       const matchingStock = stockData.find(
    //         (stockItem) =>
    //           stockItem.SalesPersonId === cartItem.SalePersonId &&
    //           stockItem.Id === cartItem.ProductId &&
    //           stockItem.BrandId === cartItem.BrandId &&
    //           stockItem.WeightCategoryId === cartItem.WeightId
    //       );
  
    //       if (matchingStock) {
    //         const remainingStock = matchingStock.Quantity;
    //         if (cartItem.Quantity > remainingStock) {
    //           issues.push({
    //             Product: cartItem.ProductName,
    //             Required: cartItem.Quantity,
    //             Available: remainingStock,
    //             Restock: cartItem.Quantity - remainingStock,
    //           });
    //         }
    //       } else {
    //         issues.push({
    //           Product: cartItem.ProductName,
    //           Error: "No matching stock found for the item",
    //         });
    //       }
    //     }
  
    //     if (issues.length > 0) {
    //       alertIssues(issues);
    //     } else {
    //       alert("All items are approved successfully!");
    //       // Optionally reload grid data here after approval
       
    //     }
    //   } else {
    //     console.error("Invalid response format from API");
    //   }
    // } catch (error) {
    //   console.error("Error fetching stock data:", error);
    // }
  };
  

  const alertIssues = (issues) => {
    let message = "Stock issues found:\n";
    issues.forEach((issue) => {
      if (issue.Error) {
        message += `Product: ${issue.Product}, Error: ${issue.Error}\n`;
      } else {
        message += `Product: ${issue.Product}, Required: ${issue.Required}, Available: ${issue.Available}, Restock: ${issue.Restock}\n`;
      }
    });
    alert(message);
  };

  const btnDeleteOnClick = (formData) => {
    // Delete item logic
  };

  const data = useMemo(() => gridData || [], [gridData]);

  const columns = useMemo(
    () => [
      {
        Header: "CustomerName",
        accessor: "CustomerName",
        Cell: ({ row }) =>
          row.original.showCustomerDetails ? row.original.CustomerName : null,
      },
      {
        Header: "SalesPerson",
        accessor: "SalesPerson",
        Cell: ({ row }) =>
          row.original.showCustomerDetails ? row.original.SalesPerson : null,
      },
      {
        Header: "CartTotal",
        accessor: "CartTotal",
        Cell: ({ row }) =>
          row.original.showCustomerDetails ? row.original.CartTotal : null,
      },
      {
        Header: "WeightCategory",
        accessor: "WeightCategory",
      },
      {
        Header: "BrandName",
        accessor: "BrandName",
      },
      {
        Header: "ProductName",
        accessor: "ProductName",
      },
      {
        Header: "Quantity",
        accessor: "Quantity",
      },
      {
        Header: "Amount",
        accessor: "Amount",
      },
      {
        Header: "Status",
        accessor: "IsAdminApproved",
        Cell: ({ row }) =>
          row.original.showEditButton ? (
            (() => {
              const { IsAdminApproved, Id } = row.original;

              if (IsAdminApproved === true) {
                return <span className="text-success">Approved</span>;
              } else if (IsAdminApproved === false) {
                return <span className="text-danger">Rejected</span>;
              } else {
                return (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handleApprove(row.original)}
                  >
                    Approve
                  </Button>
                );
              }
            })()
          ) : null,
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="page-content">
    <Container fluid={true}>
    <Breadcrumbs title={breadCrumbTitle} breadcrumbItem={breadcrumbItem} />

      <Row className="mb-2">
        <Col md="4">
          <FormControl
            type="text"
            placeholder="Search"
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="mb-2"
          />
        </Col>
        <Col md="4">
          <Button
            type="button"
            onClick={btnAddOnClick}
            variant="success"
            className="mb-2"
          >
            Add New
          </Button>
        </Col>
      </Row>

      <Table {...getTableProps()} responsive bordered striped>
  <thead>
    {headerGroups.map((headerGroup, headerGroupIndex) => (
      <tr {...headerGroup.getHeaderGroupProps()} key={headerGroupIndex}>
        {headerGroup.headers.map((column, columnIndex) => (
          <th
            {...column.getHeaderProps(column.getSortByToggleProps())}
            key={columnIndex}
          >
            {column.render("Header")}
            <span>
              {column.isSorted
                ? column.isSortedDesc
                  ? " 🔽"
                  : " 🔼"
                : ""}
            </span>
          </th>
        ))}
      </tr>
    ))}
  </thead>
  <tbody {...getTableBodyProps()}>
    {page.map((row, rowIndex) => {
      prepareRow(row);
      return (
        <tr {...row.getRowProps()} key={rowIndex}>
          {row.cells.map((cell, cellIndex) => (
            <td {...cell.getCellProps()} key={cellIndex}>
              {cell.render("Cell")}
            </td>
          ))}
        </tr>
      );
    })}
  </tbody>
</Table>


      <Row className="mt-2">
        <Col>
          <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {"<<"}
          </Button>{" "}
          <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {"<"}
          </Button>{" "}
          <Button onClick={() => nextPage()} disabled={!canNextPage}>
            {">"}
          </Button>{" "}
          <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            {">>"}
          </Button>{" "}
          <span>
            Page{" "}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{" "}
          </span>
          <span>
            | Go to page:{" "}
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
              style={{ width: "100px" }}
            />
          </span>{" "}
          <select
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
      </Row>
      </Container>
    </div>
  );
};

export default PageList_AdminCartApprove;
